"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
var _default = {
  name: 'Blank',
  components: {},
  mixins: [],
  computed: {
    key: function key() {
      return this.$route.path;
    }
  },
  methods: {}
};
exports.default = _default;